import { render, staticRenderFns } from "./ConsultarAutorizacoes.vue?vue&type=template&id=4843a0bc&scoped=true"
import script from "./ConsultarAutorizacoes.vue?vue&type=script&lang=js"
export * from "./ConsultarAutorizacoes.vue?vue&type=script&lang=js"
import style0 from "./ConsultarAutorizacoes.vue?vue&type=style&index=0&id=4843a0bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4843a0bc",
  null
  
)

export default component.exports